<!-- 商品列表 productList-->
<template>
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="goodsId"
      :searchList="searchList"
      :columns="columns"
      :searchParams.sync="searchParams"
      :listApi="listApi"
    >
      <slot>
        <template v-if="showRecommendation">
          <div style='display:block;position:relative;top:-30px;margin-bottom:-30px'>
            <a-form-item label="设置推荐位" :labelCol='{ span: 2 }'>
              <a-radio-group v-model="scopeType">
                <a-radio  :value="1">首页</a-radio>
                <a-radio  :value="2">店铺详情</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
        </template>
      </slot>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';

export default {
  mixins: [fetchSelect],
  props: {
    showRecommendation: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      scopeType: 1,
      searchList: [
        { props: ['title'], placeholder: '商品名称', options: [], inputType: 'input' },
        { props: ['shopName'], placeholder: '店铺名称', options: [], inputType: 'input' },
        {
          label: '',
          props: ['areas'],
          placeholder: '所在地区',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(2, 'searchList', '1,2', e);
          }
        }

      ],
      columns: [
        { title: '所在地区', dataIndex: 'area', align: 'left', width: '' },
        { title: '店铺名称', dataIndex: 'shopName', align: 'left', width: '' },
        { title: '商品名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '价格', dataIndex: 'price', align: 'left', width: '', customCell: row => ({ domProps: { innerHTML: '￥' + row.price} })}
      ],
      dataSource: [],
      searchParams: {
        areas: undefined,
        shopName: undefined,
        title: undefined
      },
      listApi: {
        url: '/local/goods/goodList',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(2, 'searchList', '1,2');
    },
    resHandle (res) {
      return res.rows;
    },
    searchHandle (selectData) {
      // return selectData;
    },
    getSelectId () {
      if (this.$refs.table.selectedRowKeys) {
        return this.$refs.table.selectedRowKeys;
      } else {
        return [];
      }
    },
    getSelectrow () {
      if (this.$refs.table.selectedRowKeys) {
        return this.$refs.table.selectedRows;
      } else {
        return [];
      }
    }

  }
};
</script>
